export const dummyStoreList = [
  {
    value: 'Kho mặc định',
    label: 'Kho mặc định',
  },
  {
    value: 'Kho 1',
    label: 'Kho 1',
  },
  {
    value: 'Kho 2',
    label: 'Kho 2',
  },
  {
    value: 'Kho 3',
    label: 'Kho 3',
  },
]

export const dummyPriceList = [
  {value: 'Bảng giá lẻ', label: 'Bảng giá lẻ'},
  {value: 'Bảng 1', label: 'Bảng 1'},
  {value: 'Bảng 2', label: 'Bảng 2'},
]
export const deliveryPartners = [
  {value: 'evoshop', label: 'evoshop'},
  {value: 'Giao hàng tiết kiệm', label: 'Giao hàng tiết kiệm'},
  {value: 'Giao hàng nhanh', label: 'Giao hàng nhanh'},
  {value: 'Viettel Post', label: 'Viettel Post'},
  {value: 'SuperShip', label: 'SuperShip'},
]

export const dummyShippingList = [
  {
    value: 'Nguyễn Tuấn Khánh - 097 353 3994',
    label: 'Nguyễn Tuấn Khánh - 097 353 3994',
  },
  {value: 'Nguyen Van A - 0789 156 823', label: 'Nguyen Van A - 0789 156 823'},
]

export const districtList = [
  {value: 'TPHCM/Quận 1', label: 'TPHCM/Quận 1'},
  {value: 'TPHCM/Quận 2', label: 'TPHCM/Quận 2'},
  {value: 'TPHCM/Quận 3', label: 'TPHCM/Quận 3'},
]
export const wardList = [
  {value: 'Phường Bến Thành', label: 'Phường Bến Thành'},
  {value: 'Phường Bến Thành', label: 'Phường Bến Thành'},
  {value: 'Phường Bến Thành', label: 'Phường Bến Thành'},
]
